export enum ModalType {
  confirmation = 'confirmation',
  genericError = 'genericError',
  sendError = 'sendError',
  success = 'success',
}
